document.addEventListener('change', (event) => {
  const target = event.target;
  if (!target || !target.matches('[data-cart-attribute]')) return;

  event.stopPropagation();

  const name = target.dataset.attributeName;
  if (!name) return;

  let value = '';
  if (target.type === 'checkbox') {
    value = target.checked ? target.dataset.attributeCheckedValue || target.value || 'Yes' : '';
  } else {
    value = target.value;
  }

  const body = JSON.stringify({ attributes: { [name]: value } });
  const cartItems = document.querySelector('cart-items');

  fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then(() => {
      if (
        name === (window.bhiWarrantySettings?.attributeName || 'Extended Warranty')
        && window.BHIWarranty?.enabled
        && window.BHIWarranty?.sync
      ) {
        return window.BHIWarranty.sync({ refreshUi: true });
      }

      if (cartItems && typeof cartItems.onCartUpdate === 'function') {
        return cartItems.onCartUpdate();
      }
    })
    .catch((error) => {
      console.error(error);
    });
});
